import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { GenQuickOrderLinkComponent } from './quick-order-link.component';
import { GenericLinkModule } from '@spartacus/storefront';

@NgModule({
  imports: [
    CommonModule,
    GenericLinkModule,
  ],
  declarations: [GenQuickOrderLinkComponent],
  exports: [GenQuickOrderLinkComponent],
})
export class GenQuickOrderLinkModule {}
